module.exports = __webpack_public_path__ + "static/media/sle.da5e6211.svg";